import { post,get, postJson,postBlob,imagePost,deleteApiJson } from '../axios'

const RESOURCE_BASE_PATH = ''

/***
 * 查询导出文件记录
 * @param p
 */
export const queryExportFileRecord = p => post(`${RESOURCE_BASE_PATH}/queryExportFileRecord`, p);
/*
 * 删除导出文件记录
 * @param p
 */
export const delectExportFileRecord = p => post(`${RESOURCE_BASE_PATH}/delectExportFileRecord`, p);

export const batchExport = p => get(`${RESOURCE_BASE_PATH}/batchExport`, p,"blob");

// 1.获取导出管理列表
export const getSellerExport = p => get(`${RESOURCE_BASE_PATH}/seller-export-file/list`, p);

// 2.删除导出管理列表
export const deleteSellerExport = p => deleteApiJson(`${RESOURCE_BASE_PATH}/seller-export-file`, p);

// 3，导出按钮
export const ExportFile = p => postBlob(`${RESOURCE_BASE_PATH}/seller-export-file`, p);

// 4.获取当前登录账号信息
export const querySellerSetting = p => get(`tbPhoneBinding/accountSetting`, p);

// 5.获取验证码
export const sendSmsSellerCode = p => get(`${RESOURCE_BASE_PATH}/seller-export-file/code`, p);
